export default "__VITE_ASSET__ZcVW0dbp__"